import React from "react";
import useHelper from "../../hooks/useHelper";

export default function TeamLogo({ team, week, size, linkPath, styleProps }) {
  const helper = useHelper();

  if (!team || !team.hasLoaded()) return null;

  if (!size) size = "sm";

  return (
    <span title={team.fullName}>
      {helper.getTeamLogoImg(team, week, size, linkPath, styleProps)}
    </span>
  );
}
